// extracted by mini-css-extract-plugin
export default {"addressTitle":"getStarted_addressTitle__CgIvP","line":"getStarted_line__0rK5j","wrappProcessor":"getStarted_wrappProcessor__nXM9A"};